import {
  //
  ADD_HOME_GROUP_STAFF,
  ADD_HOME_GROUP_STAFF_FAILURE,
  ADD_HOME_GROUP_STAFF_SUCCESS,
  //
  DELETE_HOME_GROUP_STAFF,
  DELETE_HOME_GROUP_STAFF_FAILURE,
  DELETE_HOME_GROUP_STAFF_SUCCESS,
  //
  EDIT_HOME_GROUP_STAFF,
  EDIT_HOME_GROUP_STAFF_FAILURE,
  EDIT_HOME_GROUP_STAFF_SUCCESS,
  //
  FETCH_HOME_GROUP_STAFFS,
  FETCH_HOME_GROUP_STAFFS_FAILURE,
  FETCH_HOME_GROUP_STAFFS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_STAFF_ADD_MODAL,
  CLOSE_STAFF_ADD_MODAL,
  //
  OPEN_STAFF_EDIT_MODAL,
  CLOSE_STAFF_EDIT_MODAL,
  SET_STAFF_SUCCESS,
  SET_STAFF_FAILURE,
  //
  TOGGLE_INVITE_MODAL,
  //
  INVITE_STAFF,
  INVITE_STAFF_SUCCESS,
  INVITE_STAFF_FAILURE,
} from "./constants";

// List
export const fetchHomeGroupStaffs = (payload) => ({
  type: FETCH_HOME_GROUP_STAFFS,
  payload,
});
export const fetchHomeGroupStaffsSuccess = (payload) => ({
  type: FETCH_HOME_GROUP_STAFFS_SUCCESS,
  payload,
});
export const fetchHomeGroupStaffsFailure = (payload) => ({
  type: FETCH_HOME_GROUP_STAFFS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addHomeGroupStaff = (payload) => ({
  type: ADD_HOME_GROUP_STAFF,
  payload,
});
export const addHomeGroupStaffSuccess = (payload) => ({
  type: ADD_HOME_GROUP_STAFF_SUCCESS,
  payload,
});
export const addHomeGroupStaffFailure = (payload) => ({
  type: ADD_HOME_GROUP_STAFF_FAILURE,
  payload,
});
// EDIT
export const editHomeGroupStaff = (payload) => ({
  type: EDIT_HOME_GROUP_STAFF,
  payload,
});
export const editHomeGroupStaffSuccess = (payload) => ({
  type: EDIT_HOME_GROUP_STAFF_SUCCESS,
  payload,
});
export const editHomeGroupStaffFailure = (payload) => ({
  type: EDIT_HOME_GROUP_STAFF_FAILURE,
  payload,
});
// DELETE
export const deleteHomeGroupStaff = (payload, onDeleteSuccess) => ({
  type: DELETE_HOME_GROUP_STAFF,
  payload,
  onDeleteSuccess,
});
export const deleteHomeGroupStaffSuccess = (payload) => ({
  type: DELETE_HOME_GROUP_STAFF_SUCCESS,
  payload,
});
export const deleteHomeGroupStaffFailure = (payload) => ({
  type: DELETE_HOME_GROUP_STAFF_FAILURE,
  payload,
});
//
export const openStaffAddModal = (payload) => ({
  type: OPEN_STAFF_ADD_MODAL,
  payload,
});
export const closeStaffAddModal = (payload) => ({
  type: CLOSE_STAFF_ADD_MODAL,
  payload,
});
export const openStaffEditModal = (payload) => ({
  type: OPEN_STAFF_EDIT_MODAL,
  payload,
});
export const closeStaffEditModal = (payload) => ({
  type: CLOSE_STAFF_EDIT_MODAL,
  payload,
});
export const setStaffSuccess = (payload) => ({
  type: SET_STAFF_SUCCESS,
  payload,
});
export const setStaffFailure = (payload) => ({
  type: SET_STAFF_FAILURE,
  payload,
});
//
export const toggleInviteModal = (payload) => ({
  type: TOGGLE_INVITE_MODAL,
  payload,
});
//
export const inviteStaff = (payload, onInvSuccess) => ({
  type: INVITE_STAFF,
  payload,
  onInvSuccess,
});
export const inviteStaffSuccess = (payload) => ({
  type: INVITE_STAFF_SUCCESS,
  payload,
});
export const inviteStaffFailure = (payload) => ({
  type: INVITE_STAFF_FAILURE,
  payload,
});
